<script>
    import { toast } from 'bulma-toast'
    import { userStore, usersStore, adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import UsersService from '../$services/users.service'
    import DateMethods from '../$methods/date.methods'

    import UserInfoView from './view.user.info.svelte'
    import UsersReport from './component.users.report.svelte'
    import UserSelect from './component.users.select.svelte'

    import ButtonModal from '../$components/button.modal.svelte'
    import Search from '../$components/input.search.svelte'
    import Select from '../$components/select.svelte'
    import Button from '../$components/button.svelte'
    import Table from '../$components/table.svelte'

    let loading = false
    let metadata = {}
    let query = {
        find: '',
        page: 0,
        created: -1,
        role: '',
        domain: '',
        status: 'enabled',
        sellerId: $adminStore.role === 'seller' ? $adminStore._id : null,
        adviserId: $adminStore.role === 'adviser' ? $adminStore._id : null,
    }

    getUsers()

    async function getUsers() {

        loading = true
        const resp = await UsersService.getUsers(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        metadata = resp.data.metadata
        usersStore.set(resp.data.users)
    }
</script>

{#if !$userStore}
    <Table items={ $usersStore.length } { loading } bind:metadata bind:page={query.page} on:change={getUsers} skeletonCols={6}>
        <div slot="header" class="header-filters">
            <div class="header-top">
                <Search bind:value={query.find} on:enter={getUsers} />
                {#if isPermission($adminStore, 'UsersView.User.Report')}
                    <UsersReport />
                {/if}
                {#if isPermission($adminStore, 'UsersView.User.Create')}
                    <ButtonModal modalId="users_create_modal" text="Crear usuario" icon="user-plus" />
                {/if}
            </div>
            {#if $adminStore.role === 'admin'}
                <div class="header-actions">
                    <Select bind:value={query.role} on:change={getUsers} text="Rol de usuario" size="small" options={[
                        {value: "user", text:"Usuario"},
                        {value: "admin", text:"Administrador"},
                        {value: "seller", text:"Vendedor"},
                        {value: "adviser", text:"Asesor"},
                    ]} />
                    <Select bind:value={query.status} on:change={getUsers} text="Estatus" size="small" options={[
                        {value: "enabled", text:"Activo"},
                        {value: "disabled", text:"Inactivo"}
                    ]}/>
                </div>
            {/if}
        </div>
        <thead slot="thead">
            <tr>
                <th>#</th>
                <th>
                    <span class="icon-text">
                        <span class="icon"><i class="fas fa-user"></i></span>
                        <span>Nombre</span>
                    </span>
                </th>
                <th>
                    <span class="icon-text">
                        <span class="icon"><i class="fas fa-envelope"></i></span>
                        <span>Contacto</span>
                    </span>
                </th>
                <th>
                    <span class="icon-text">
                        <span class="icon"><i class="fas fa-phone"></i></span>
                        <span>Teléfono</span>
                    </span>
                </th>
                <th>
                    <span class="icon-text">
                        <span class="icon"><i class="fas fa-calendar"></i></span>
                        <span>Fecha</span>
                        <span on:click={() => { query.created = query.created * -1; getUsers() }} class="icon pointer" style="cursor:pointer; margin-left: 0.25rem;">
                            <i class="fas fa-sort"></i>
                        </span>
                    </span>
                </th>
                <th>
                    <span class="icon-text">
                        <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                        <span>Acciones</span>
                    </span>
                </th>
            </tr>
        </thead>
        <tbody slot="tbody">
            {#each $usersStore as user, index}
                <tr>
                    <td><span>{metadata?.items != null ? (metadata.items * (query.page ?? 0)) + (index + 1) : index + 1}</span></td>
                    <td>{ user.name }</td>
                    <td>{ user.email }</td>
                    <td>{ user.phone }</td>
                    <td>{ DateMethods.dateLarge(user.created) }</td>
                    <td><Button on:click={() => userStore.set(user)} icon="ellipsis-v" /></td>
                </tr>
            {/each}
        </tbody>
    </Table>
{/if}
{#if $userStore}
    <UserInfoView />
{/if}
